import React from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/fe-toolbox'

import { LayoutWithHeader as Layout } from 'components/Layout'
import { EmptyState, EmptyStateAction } from 'components/EmptyState'
import { useSafeRouter } from 'hooks/useSafeRouter'

import type { FallbackProps } from 'react-error-boundary'

export function PelatihanErrorFallback({
  error,
  resetErrorBoundary,
}: FallbackProps) {
  const router = useRouter()
  const { safeReplace } = useSafeRouter()
  // @ts-expect-error error is not an Error object
  const { title, description } = error

  return (
    <Layout
      title=""
      onClickBack={() =>
        historyUtils.backToApp(() => {
          resetErrorBoundary()
          router.back()
        })
      }
    >
      <Head>
        <title>{title}</title>
      </Head>
      <EmptyState title={title} description={description}>
        <EmptyStateAction
          color="black"
          onClick={() => {
            safeReplace(
              `/${
                process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH ||
                'pelatihan-mandiri'
              }`
            )
          }}
        >
          Kembali ke daftar Topik
        </EmptyStateAction>
      </EmptyState>
    </Layout>
  )
}

export default PelatihanErrorFallback
